import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { fetchUnapprovedPendingCount } from '../../redux/slices/UnapprovedStripePayoutsSlice';
import TabMenus from '../../shared-components/tab-menus/TabMenus';

import ApprovedStripePayouts from './components/ApprovedStripePayouts';
import RejectedStripePayouts from './components/RejectedStripePayouts';
import UnapprovedStripPayouts from './components/UnapprovedStripPayouts';

/**
 * Stripe payouts components
 * @returns
 */
function StripePayouts() {
  const { t, i18n } = useTranslation('stripePayout');
  const dispatch = useAppDispatch();
  const { pendingNotificationCount } = useAppSelector((state) => state.unapprovedStripePayouts);
  const [openTab, setOpenTab] = useState<number>(0);
  const { currentPage } = useParams<{ currentPage: string }>();

  /**
   * Handle the tab change function
   * @param number
   */
  const changeTabPages = (number: number) => {
    setOpenTab(number);
    let pageName = '';
    switch (number) {
      case 0:
        pageName = 'approved';
        break;
      case 1:
        pageName = 'unapproved';
        break;
      case 2:
        pageName = 'rejected';
        break;

      default:
        break;
    }
    window.history.pushState({}, '', `${pageName}`);
  };

  useEffect(() => {
    if (currentPage) {
      let number = 0;
      switch (currentPage) {
        case 'approved':
          number = 0;
          break;
        case 'unapproved':
          number = 1;
          break;
        case 'rejected':
          number = 2;
          break;

        default:
          break;
      }
      setOpenTab(number);
    }
  }, []);
  useEffect(() => {
    dispatch(fetchUnapprovedPendingCount());
  }, []);
  return (
    <div className="stripe-payouts-wrap" dir={i18n.dir()}>
      <div className="stripe-payouts-container">
        <div className="body-container">
          <div className="table-tab">
            <TabMenus
              menus={[
                {
                  name: t('approved'),
                },
                {
                  name: t('pending'),
                  count: pendingNotificationCount,
                },
                {
                  name: t('rejected'),
                },
              ]}
              openTab={openTab}
              setOpenTab={changeTabPages}
            />
          </div>
          <div className="table-content">
            {openTab === 0 && <ApprovedStripePayouts />}
            {openTab === 1 && <UnapprovedStripPayouts />}
            {openTab === 2 && <RejectedStripePayouts />}
          </div>
        </div>
      </div>
    </div>
  );
}

export default StripePayouts;
